import { motion } from "framer-motion";
import { experience } from "../../data/portfolio";
import { SectionHead } from "./Reveal";

export default function Experience() {
  return (
    <section id="experience" data-testid="experience-section" className="relative py-28 md:py-40 bg-[#F2F2EF]/60 overflow-hidden">
      <div className="absolute rounded-full mix-blend-multiply blur-3xl opacity-40 bg-blush w-[28rem] h-[28rem] -bottom-32 -left-32 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <SectionHead eyebrow="Career" title={<>Where practice<br />meets evidence.</>} testid="experience-heading" />
        <div className="relative border-l border-stone ml-2 md:ml-6 max-w-3xl">
          {experience.map((job, i) => (
            <motion.article
              key={job.role + job.org}
              data-testid={`experience-item-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-70px" }}
              transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: i * 0.08 }}
              className="relative pl-10 md:pl-14 pb-16 last:pb-0 group"
            >
              <span className={`absolute -left-[7px] top-2 w-3.5 h-3.5 rounded-full border-2 border-paper transition-colors duration-500 ${job.current ? "bg-ink" : "bg-sage group-hover:bg-ink"}`} />
              <div className="flex flex-wrap items-baseline gap-x-4 gap-y-1">
                <h3 className="font-display text-2xl md:text-3xl font-medium text-ink tracking-tight">{job.role}</h3>
                {job.current && (
                  <span className="pill-tag !text-ink !border-sage bg-sage/30">Current</span>
                )}
              </div>
              <p className="mt-1.5 text-sm font-medium text-fog tracking-wide">
                {job.org} · {job.place}
              </p>
              <p className="mt-1 text-xs font-semibold tracking-[0.2em] uppercase text-ink/40">{job.dates}</p>
              <ul className="mt-5 space-y-2.5">
                {job.points.map((p) => (
                  <li key={p.slice(0, 24)} className="text-sm md:text-[15px] leading-relaxed text-fog flex gap-3">
                    <span className="mt-2.5 w-4 h-px bg-sage shrink-0" />
                    {p}
                  </li>
                ))}
              </ul>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
